module.exports = __webpack_public_path__ + "img/expert-list.cfc9a986.png";